meedy.controller('meedy.patientTermReassignController', ['$scope', '$state', '$q', '$mdDialog', '$timeout', '$mdToast', 'meedy.objectHelper', 'applicationModel',
	'meedy.resourceModel', 'meedy.availabilityRuleModel', 'meedy.userModel', 'meedy.termModel', 'term',
    function ($scope, $state, $q, $mdDialog, $timeout, $mdToast, objectHelper, applicationModel,
			  resourceMode, availabilityRuleModel, userModel, termModel, term) {
		function calculatePrivateTermEndDate(date, useDefault) {
			var dateMoment = moment(date).clone();
			if (useDefault) {
				return dateMoment.add(60, 'minutes').clone().toDate();
			}
			else {
				return dateMoment.add(10, 'minutes').clone().toDate();
			}
		}
	
		function calculateAvailabilityRuleDates(availabilityRuleLocal, appointmentLength) {
			var availableDates = [];
			var GRANULAR = 5;
		
			var currentDateMoment = moment(availabilityRuleLocal.availabilityRule.startDate);
			var endDateMoment = availabilityRuleLocal.granular ? moment(availabilityRuleLocal.availabilityRule.endDate.getTime() - (appointmentLength * 60 * 1000)) + (60 * 1000 * GRANULAR)
				: moment(availabilityRuleLocal.availabilityRule.endDate.getTime());
		
			var endOfRuleReached = false;
		
			while (!endOfRuleReached) {
				var newDateMoment = currentDateMoment.clone().add((availabilityRuleLocal.granular ? 5 : appointmentLength), 'minutes');
				if (newDateMoment.isSameOrBefore(endDateMoment)) {
					availableDates.push(currentDateMoment.clone().toDate());
					currentDateMoment = newDateMoment;
				}
				else {
					endOfRuleReached = true;
				}
			}
		
			return availableDates;
		}
	
		function setData() {
			// isolated scope, needs these injected again
			$scope.Enum = Enum;
			$scope.Constant = Constant;
			
			$scope.viewState = 'MainView';
			$scope.conflictingTerms = [];
			
			$scope.term = objectHelper.cloneObject(term);
			$scope.termCopy = objectHelper.cloneObject(term);
			
		
			$scope.currentDate = new Date();
		
			$scope.appointmentData = {
				appointmentLengths: [ 5, 10, 15, 20, 30, 45, 60, 90, 120 ],
				appointmentLength: undefined,
				availableTerms: [],
				availabilityRuleRange: {
					startDate: $scope.currentDate,
					days: 4,
					resourceId: $scope.term.resource.id
				},
				availableAppointmentStartDateOptions: [
					objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.REASSIGN_POPUP.APPOINTMENT_DATE_OPTION.NEAREST', value: $scope.currentDate }),
					objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.REASSIGN_POPUP.APPOINTMENT_DATE_OPTION.IN_A_WEEK', value: moment($scope.currentDate).clone().add(7, 'days').toDate() }),
					objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.REASSIGN_POPUP.APPOINTMENT_DATE_OPTION.IN_A_MONTH', value: moment($scope.currentDate).clone().add(1, 'months').toDate() }),
					objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.REASSIGN_POPUP.APPOINTMENT_DATE_OPTION.IN_3_MONTHS', value: moment($scope.currentDate).clone().add(3, 'months').toDate() })
				],
				availableAppointmentStartDateOption: $scope.currentDate,
				selectedAvailabilityRuleLocal: null
			};
		
			var appointmentLength = moment($scope.term.end).diff(moment($scope.term.begin), 'minutes');
			$scope.appointmentData.appointmentLength = _.find($scope.appointmentData.appointmentLengths, function (length) {
				return (length == appointmentLength);
			});
		
			$scope.forms = {};
		}
	
		function setPermissions() {
		    
		}
	
		function setListeners() {
			$scope.$watch(function () {
				return applicationModel.actionInProgress;
			}, function (newVal) {
				$scope.actionInProgress = newVal;
			});
		
			$scope.$watch('privateTerm.begin', function (newVal, oldVal) {
				if (newVal && (!oldVal || (oldVal && (newVal.getTime() != oldVal.getTime())))) {
					$scope.privateTermData.validPrivateTermEndDate = calculatePrivateTermEndDate(newVal, false);
				}
			});
		
			$scope.$watch('appointmentData.availableAppointmentStartDateOption', function (newVal, oldVal) {
				if (newVal && (newVal != oldVal)) {
					$scope.appointmentData.availabilityRuleRange.startDate = newVal;
				
					if ($scope.appointmentData.availabilityRuleRange.resourceId) {
						availabilityRuleModel.getNearestAvailabilityRuleCacheOccurence(objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
							startDate: $scope.appointmentData.availabilityRuleRange.startDate,
							days: $scope.appointmentData.availabilityRuleRange.days,
							idResource: $scope.appointmentData.availabilityRuleRange.resourceId
						}));
					}
				}
			});
		
			$scope.$on(Event.MEEDY.AVAILABILITY_RULE.GET_NEAREST_AVAILABILITY_RULE_OCCURENCE.SUCCESS, function (event, data) {
				$scope.appointmentData.selectedAvailabilityRuleLocal = null;
			
				var upcomingTerms = _.sortBy(data, ['startDate']);
			
				var upcomingTermsLocal = [];
				_.each(upcomingTerms, function(upcomingTerm) {
					var availabilityRuleOccurenceLocal = objectHelper.o(CalendarAvailabilityRuleOccurenceLocalVO, {
						availabilityRule: upcomingTerm,
						selected: false,
						granular: false,
						availableDates: []
					});
				
					upcomingTermsLocal.push(availabilityRuleOccurenceLocal);
				});
			
				var upcomingTermsByDay = _.groupBy(upcomingTermsLocal, function (availabilityRuleOccurrenceLocal) {
					return moment(availabilityRuleOccurrenceLocal.availabilityRule.startDate).dayOfYear();
				});
			
				$scope.appointmentData.availableTerms = upcomingTermsByDay;
			});
		
			$scope.onAvailabilityRuleGranularChange = function (availabilityRuleLocal) {
				$timeout(function () {
					availabilityRuleLocal.availableDates = calculateAvailabilityRuleDates(availabilityRuleLocal, $scope.appointmentData.appointmentLength);
				});
			};
		
			$scope.onAppointmentLengthChanged = function () {
				$scope.term.begin = null;
				$scope.term.end = null;
			
				if ($scope.appointmentData.selectedAvailabilityRuleLocal) {
					$scope.appointmentData.selectedAvailabilityRuleLocal.availableDates = calculateAvailabilityRuleDates($scope.appointmentData.selectedAvailabilityRuleLocal, $scope.appointmentData.appointmentLength);
				}
				else {
					$scope.resetAvailabilityRuleState();
				}
			};
		}
	
		function setActions() {
			$scope.showMoreAvailableTerms = function() {
				$scope.appointmentData.availabilityRuleRange.days = $scope.appointmentData.availabilityRuleRange.days + 4;
				availabilityRuleModel.getNearestAvailabilityRuleCacheOccurence(objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
					startDate: $scope.appointmentData.availabilityRuleRange.startDate,
					days: $scope.appointmentData.availabilityRuleRange.days,
					idResource: $scope.appointmentData.availabilityRuleRange.resourceId
				}));
			};
		
			$scope.toggleSelectAvailabilityRule = function(availabilityRuleLocal) {
				var isSelected = availabilityRuleLocal.selected;
				$scope.resetAvailabilityRuleState();
				availabilityRuleLocal.selected = !isSelected;
			
				if (availabilityRuleLocal.selected) {
					availabilityRuleLocal.availableDates = calculateAvailabilityRuleDates(availabilityRuleLocal, $scope.appointmentData.appointmentLength);
					$scope.appointmentData.selectedAvailabilityRuleLocal = availabilityRuleLocal;
				}
			};
		
			$scope.resetAvailabilityRuleState = function() {
				_.each($scope.appointmentData.availableTerms, function(availableTermDay) {
					_.each(availableTermDay, function(existingAvailabilityRuleLocal) {
						existingAvailabilityRuleLocal.selected = false;
						existingAvailabilityRuleLocal.granular = false;
						existingAvailabilityRuleLocal.availableDates = [];
					});
				});
			
				$scope.appointmentData.selectedAvailabilityRuleLocal = null;
			};
		
			$scope.selectAvailableDate = function (date) {
				$scope.resetAvailabilityRuleState();
			
				$scope.term.begin = date;
				$scope.term.end = moment(date).clone().add($scope.appointmentData.appointmentLength, 'minutes').toDate();
			};
		
			$scope.resetAppointmentDate = function () {
				$scope.term.begin = null;
				$scope.term.end = null;
			};
			
			$scope.okConfirmation = function () {
				$scope.forms.term.$setSubmitted();
				
				if ($scope.forms.term.$valid) {
					
					termModel.checkConflicts($scope.term);
					
					var checkWatcherDisabler = $scope.$on(Event.MEEDY.TERM.CHECK_CONFLICTS.SUCCESS, function (event, list) {
						checkWatcherDisabler();
						if(list && list.length > 0) {
							$scope.conflictingTerms = [];
						} else {
							$scope.conflictingTerms = list;
						}
						
						$scope.viewState = 'ConfirmationView';
					});
				}
				
				
			};
			
			$scope.cancelConfirmation = function () {
				$scope.conflictingTerms = [];
				$scope.viewState = 'MainView';
			};
		
			$scope.save = function () {
				
				var successWatcherDisabler = null;
				var errorWatcherDisabler = null;
				
				termModel.updateTerm($scope.term);
				
				successWatcherDisabler = $scope.$on(Event.MEEDY.TERM.UPDATE_TERM.SUCCESS, function (event, result) {
					successWatcherDisabler();
					errorWatcherDisabler();
					
					var updatedTerm = result;
					$scope.forms.term.$setPristine();
					
					$mdDialog.hide(updatedTerm);
				});
				
				errorWatcherDisabler = $scope.$on(Event.MEEDY.TERM.UPDATE_TERM.ERROR, function (event, error) {
					successWatcherDisabler();
					errorWatcherDisabler();
				});
				
			};
		
			$scope.ok = function () {
				$mdDialog.hide();
			};
		
			$scope.cancel = function() {
				$mdDialog.cancel();
			};
		}
	
		function configureInterface() {
		
		}
	
		function initialize() {
			availabilityRuleModel.getNearestAvailabilityRuleCacheOccurence(objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
				startDate: $scope.appointmentData.availabilityRuleRange.startDate,
				days: $scope.appointmentData.availabilityRuleRange.days,
				idResource: $scope.appointmentData.availabilityRuleRange.resourceId
			}));
		}
	
		setData();
		setPermissions();
		setListeners();
		setActions();
		configureInterface();
		initialize();
    }
]);